import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=20f98d78&"
import script from "./Fullscreen.vue?vue&type=script&lang=js&"
export * from "./Fullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports